// import { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Modal, Spin, Drawer } from "antd";
// import { motion } from "framer-motion";
// import Slider from "react-slick";
// import { FaStar, FaFilter } from "react-icons/fa";

// import Hero from "../../common/Hero";
// import Navbar from "../../common/Navbar";
// import Footer from "../../common/Footer";
// import BlogImage from "../../assests/images/hero.jpg";

// function Ourcleaning() {
//   const [services, setServices] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [selectedSubcategory, setSelectedSubcategory] = useState("all");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [previewService, setPreviewService] = useState(null);

//   const [showFilterDrawer, setShowFilterDrawer] = useState(false);

//   const [showProviderModal, setShowProviderModal] = useState("");
//   const [providerName, setProviderName] = useState({ firstName: "", lastName: "" });
//   const navigate = useNavigate();

//   // ✅ Get logged-in user info
//   useEffect(() => {
//     const auth = localStorage.getItem("auth");
//     if (auth) {
//       const user = JSON.parse(auth)?.user;
//       if (user) {
//         setProviderName({ firstName: user.firstName, lastName: user.lastName });
//         setShowProviderModal(user.role || "");
//       }
//     }
//   }, []);

//   // ✅ Fetch services
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(`${API_BASE}/service/readAllService`);
//         const data = Array.isArray(res.data.data.services) ? res.data.data.services : [];
//         setServices(data);
//         const uniqueCategories = [...new Set(data.map((s) => s.category).filter(Boolean))];
//         setCategories(uniqueCategories);
//       } catch (err) {
//         console.error("Failed to load services:", err);
//         setError("Failed to load services. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchServices();
//   }, []);

//   // ✅ Highlight search term
//   const highlightText = (text = "", search) => {
//     if (!search) return text;
//     try {
//       const regex = new RegExp(`(${search})`, "gi");
//       return String(text).replace(regex, `<span style="background-color: yellow;">$1</span>`);
//     } catch {
//       return text;
//     }
//   };

//   // ✅ Filtered services
//   const filteredServices = services.filter((s) => {
//     const name = s.name?.toLowerCase() || "";
//     const desc = s.description?.toLowerCase() || "";
//     const cat = s.category?.toLowerCase() || "";
//     const sub = s.subcategory?.toLowerCase() || "";

//     const matchesSearch = !searchTerm || name.includes(searchTerm.toLowerCase()) || desc.includes(searchTerm.toLowerCase());
//     const matchesCat = selectedCategory === "all" || cat === selectedCategory.toLowerCase();
//     const matchesSub = selectedSubcategory === "all" || sub === selectedSubcategory.toLowerCase();

//     return matchesSearch && matchesCat && matchesSub;
//   });

//   const testimonials = [
//     { name: "Aisha", feedback: "Outstanding service! Cleaners were on time and thorough.", img: "https://randomuser.me/api/portraits/women/68.jpg", rating: 5 },
//     { name: "Ali", feedback: "They made my office spotless. Highly recommended!", img: "https://randomuser.me/api/portraits/men/76.jpg", rating: 4 },
//     { name: "Fatima", feedback: "Great attention to detail. Will book again!", img: "https://randomuser.me/api/portraits/women/45.jpg", rating: 5 },
//   ];

//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     speed: 800,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     responsive: [{ breakpoint: 1024, settings: { slidesToShow: 1 } }],
//   };

//   const FilterContent = () => (
//     <div className="p-4">
//       <h3 className="text-xl font-bold mb-4 text-orange-400">Filter by Category</h3>
//       <button
//         onClick={() => {
//           setSelectedCategory("all");
//           setSelectedSubcategory("all");
//         }}
//         className={`block w-full text-left px-3 py-2 rounded-md mb-2 ${
//           selectedCategory === "all" ? "bg-orange-600" : "bg-gray-800 hover:bg-gray-700"
//         }`}
//       >
//         All Categories
//       </button>
//       {categories.map((cat) => (
//         <button
//           key={cat}
//           onClick={() => {
//             setSelectedCategory(cat);
//             setSelectedSubcategory("all");
//           }}
//           className={`block w-full text-left px-3 py-2 rounded-md mb-2 ${
//             selectedCategory === cat ? "bg-orange-600" : "bg-gray-800 hover:bg-gray-700"
//           }`}
//         >
//           {cat}
//         </button>
//       ))}

//       {selectedCategory !== "all" && (
//         <>
//           <h3 className="text-xl font-bold mt-6 mb-3 text-orange-400">Subcategories</h3>
//           <button
//             onClick={() => setSelectedSubcategory("all")}
//             className={`block w-full text-left px-3 py-2 rounded-md mb-2 ${
//               selectedSubcategory === "all" ? "bg-orange-600" : "bg-gray-800 hover:bg-gray-700"
//             }`}
//           >
//             All
//           </button>
//           {[...new Set(services.filter((s) => s.category === selectedCategory).map((s) => s.subcategory))].map(
//             (sub) =>
//               sub && (
//                 <button
//                   key={sub}
//                   onClick={() => setSelectedSubcategory(sub)}
//                   className={`block w-full text-left px-3 py-2 rounded-md mb-2 ${
//                     selectedSubcategory === sub ? "bg-orange-600" : "bg-gray-800 hover:bg-gray-700"
//                   }`}
//                 >
//                   {sub}
//                 </button>
//               )
//           )}
//         </>
//       )}
//     </div>
//   );
// const API_BASE = process.env.REACT_APP_API_BASE;

//   return (
//     <>
//       {/* Welcome Modal */}
//       {/* <Modal open={Boolean(showProviderModal)} onCancel={() => setShowProviderModal("")} footer={null} centered>
//         <div className="text-center py-6">
//           {showProviderModal === "provider" ? (
//             <>
//               <h2 className="text-2xl font-bold mb-2">Welcome Dear Employee!</h2>
//               <p className="text-lg">
//                 Mr. {providerName.firstName} {providerName.lastName}, check your profile for orders.
//               </p>
//               <button
//                 onClick={() => navigate("/Profile")}
//                 className="bg-orange-600 w-60 text-white py-2 mt-6 rounded hover:bg-orange-700"
//               >
//                 Profile
//               </button>
//             </>
//           ) : showProviderModal === "user" ? (
//             <>
//               <h2 className="text-2xl font-bold mb-2">Welcome Dear Customer!</h2>
//               <p className="text-lg">
//                 {providerName.firstName} {providerName.lastName}, view your order history in your profile.
//               </p>
//               <button
//                 onClick={() => navigate("/Profile")}
//                 className="bg-orange-600 w-60 text-white py-2 mt-6 rounded hover:bg-orange-700"
//               >
//                 Profile
//               </button>
//             </>
//           ) : null}
//         </div>
//       </Modal> */}

// {/* Welcome Modal */}
//   <Modal
//     open={Boolean(showProviderModal)}
//     onCancel={() => setShowProviderModal("")}
//     footer={null}
//     centered
//   >
//     <div className="text-center py-6">
//       {showProviderModal === "provider" ? (
//         <>
//           <h2 className="text-2xl font-bold mb-2">Welcome Dear Employee!</h2>
//           <p className="text-lg">
//             Mr. {providerName.firstName} {providerName.lastName}, check your profile for orders.
//           </p>
//           <button
//             onClick={() => navigate("/Profile")}
//             className="bg-orange-600 w-60 text-white py-2 mt-6 rounded hover:bg-orange-700"
//           >
//             Go to Profile
//           </button>
//         </>
//       ) : showProviderModal === "user" ? (
//         <>
//           <h2 className="text-2xl font-bold mb-2">Welcome Dear Customer!</h2>
//           <p className="text-lg">
//             {providerName.firstName} {providerName.lastName}, view your order history in your profile.
//           </p>
//           <button
//             onClick={() => navigate("/Profile")}
//             className="bg-orange-600 w-60 text-white py-2 mt-6 rounded hover:bg-orange-700"
//           >
//             Go to Profile
//           </button>
//         </>
//       ) : showProviderModal === "admin" ? (
//         <>
//           <h2 className="text-2xl font-bold mb-2 text-orange-600">Hello Admin!</h2>
//           <p className="text-lg">
//             {providerName.firstName} {providerName.lastName}, to manage the system, open your dashboard below.
//           </p>
//           <button
//             onClick={() => navigate("/admin")}
//             className="bg-orange-600 w-60 text-white py-2 mt-6 rounded hover:bg-orange-700"
//           >
//             Go to Admin Dashboard
//           </button>
//         </>
//       ) : null}
//     </div>
//   </Modal>

//       <Navbar />
//       <Hero text="Reliable Cleaning Services" text1="Home & Commercial Solutions" image={BlogImage} />

//       <section className="bg-[#121212] text-white py-16 px-4 md:px-8">
//         <h2 className="text-4xl font-bold text-center mb-10">Our Services</h2>

//         <div className="flex flex-col md:flex-row gap-6">
//           {/* Sidebar for Desktop */}
//           <aside className="hidden md:block md:w-1/4 bg-gray-900 rounded-xl p-5 h-fit sticky top-24">
//             <FilterContent />
//           </aside>

//           {/* Mobile Filter Button */}
//           <div className="md:hidden mb-4 flex justify-center">
//             <button
//               onClick={() => setShowFilterDrawer(true)}
//               className="bg-orange-600 flex items-center gap-2 text-white px-4 py-2 rounded-md hover:bg-orange-700"
//             >
//               <FaFilter /> Filter
//             </button>
//           </div>

//           {/* Drawer for Mobile */}
//           <Drawer
//             title="Filter Services"
//             placement="left"
//             onClose={() => setShowFilterDrawer(false)}
//             open={showFilterDrawer}
//             bodyStyle={{ backgroundColor: "#1f1f1f", color: "white" }}
//           >
//             <FilterContent />
//           </Drawer>

//           {/* Main Service Grid */}
//           <div className="flex-1">
//             {/* Search */}
//             <div className="mb-6">
//               <input
//                 type="search"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 placeholder="Search services..."
//                 className="w-full bg-gray-800 text-white placeholder-gray-400 px-4 py-2 rounded-md border border-gray-700 focus:outline-none"
//               />
//             </div>

//             {loading ? (
//               <div className="flex justify-center items-center py-20">
//                 <Spin size="large" />
//               </div>
//             ) : error ? (
//               <p className="text-center text-red-500">{error}</p>
//             ) : (
//               // <div className="flex flex-wrap justify-center gap-6">
//               //   {filteredServices.length ? (
//               //     filteredServices.map((service, i) => (
//               //       <motion.div
//               //         key={i}
//               //         initial={{ opacity: 0, y: 40 }}
//               //         whileInView={{ opacity: 1, y: 0 }}
//               //         transition={{ duration: 0.5 }}
//               //         viewport={{ once: true }}
//               //         className="w-full md:w-80 bg-gray-800 rounded-xl shadow-lg overflow-hidden hover:scale-105 transition-transform"
//               //       >
//               //         <img
//               //           src={service.image || "https://source.unsplash.com/400x300/?cleaning"}
//               //           alt={service.name}
//               //           className="w-full h-52 object-cover cursor-pointer"
//               //           onClick={() => setPreviewService(service)}
//               //         />
//               //         <div className="p-4">
//               //           <h3
//               //             className="text-xl font-semibold text-orange-400"
//               //             dangerouslySetInnerHTML={{ __html: highlightText(service.name, searchTerm) }}
//               //           />
//               //           <p
//               //             className="text-gray-300 mt-2 line-clamp-2"
//               //             dangerouslySetInnerHTML={{ __html: highlightText(service.description, searchTerm) }}
//               //           />
//               //           <Link to="/book">
//               //             <button className="mt-4 w-full bg-orange-600 text-white py-2 rounded hover:bg-orange-700">
//               //               Book Now
//               //             </button>
//               //           </Link>
//               //         </div>
//               //       </motion.div>
//               //     ))
//               //   ) : (
//               //     <p>No matching services found.</p>
//               //   )}
//               // </div>
//               <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
//   {filteredServices.length ? (
//     filteredServices.map((service, i) => (
//       <motion.div
//         key={i}
//         initial={{ opacity: 0, y: 40 }}
//         whileInView={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.4 }}
//         viewport={{ once: true }}
//         className="bg-gray-900 rounded-xl overflow-hidden border border-gray-800 hover:border-orange-500 hover:shadow-lg transition-all duration-300"
//       >
//         <div
//           className="relative group cursor-pointer"
//           onClick={() => setPreviewService(service)}
//         >
//           <img
//             src={service.image || "https://source.unsplash.com/400x300/?cleaning"}
//             alt={service.name}
//             className="w-full h-56 object-cover transform group-hover:scale-105 transition-transform duration-300"
//           />
//           <div className="absolute top-2 left-2 bg-orange-600 text-xs font-semibold px-2 py-1 rounded">
//             Popular
//           </div>
//         </div>

//         <div className="p-4 space-y-2">
//           <h3
//             className="text-lg font-semibold text-white line-clamp-1"
//             dangerouslySetInnerHTML={{ __html: highlightText(service.name, searchTerm) }}
//           />
//           <p
//             className="text-gray-400 text-sm line-clamp-2"
//             dangerouslySetInnerHTML={{ __html: highlightText(service.description, searchTerm) }}
//           />
//           <div className="flex items-center justify-between mt-3">
//             <span className="text-orange-500 font-bold text-base">${
//               service.price || "N/A"
//             }</span>
//             <Link to="/book">
//               <button className="bg-orange-600 hover:bg-orange-700 text-white text-sm px-3 py-1.5 rounded-md">
//                 Book Now
//               </button>
//             </Link>
//           </div>
//         </div>
//       </motion.div>
//     ))
//   ) : (
//     <p className="text-center text-gray-400 col-span-full">No matching services found.</p>
//   )}
// </div>

//             )}
//           </div>
//         </div>

//         {/* Preview Modal */}
//         <Modal
//           open={!!previewService}
//           onCancel={() => setPreviewService(null)}
//           footer={null}
//           centered
//           width={900}
//           bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
//         >
//           {previewService && (
//             <div className="flex flex-col md:flex-row gap-6 items-start">
//               <div className="md:w-2/3 w-full h-96 overflow-y-auto">
//                 <img
//                   src={previewService.image || "https://source.unsplash.com/900x700/?cleaning"}
//                   alt={previewService.name}
//                   className="w-full object-contain rounded-lg shadow-lg"
//                 />
//               </div>
//               <div className="md:w-1/3 w-full flex flex-col justify-center">
//                 <h3 className="text-3xl font-bold text-orange-500 mb-4">{previewService.name}</h3>
//                 <p className="text-gray-700 mb-6">{previewService.description}</p>
//                 <Link to="/book">
//                   <button className="bg-orange-600 text-white px-6 py-3 rounded hover:bg-orange-700">
//                     Book Now
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           )}
//         </Modal>
//       </section>

//       {/* Testimonials */}
//       <section className="bg-gray-900 text-white py-16 px-4 text-center">
//         <h2 className="text-4xl font-bold mb-8">Happy Clients</h2>
//         <Slider {...sliderSettings}>
//           {testimonials.map((client, i) => (
//             <div key={i} className="bg-gray-800 p-6 rounded-xl mx-4 shadow-lg">
//               <img src={client.img} alt={client.name} className="w-20 h-20 rounded-full mx-auto mb-4 border-4 border-orange-500" />
//               <p className="italic mb-4">“{client.feedback}”</p>
//               <div className="flex justify-center mb-2">
//                 {[...Array(client.rating)].map((_, idx) => (
//                   <FaStar key={idx} className="text-yellow-400" />
//                 ))}
//               </div>
//               <h4 className="mt-2 font-bold">{client.name}</h4>
//             </div>
//           ))}
//         </Slider>
//       </section>

//       {/* CTA */}
//       <section className="bg-orange-600 text-white text-center py-16 px-4">
//         <motion.h2
//           initial={{ opacity: 0, scale: 0.8 }}
//           whileInView={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.6 }}
//           className="text-4xl font-bold mb-4"
//         >
//           Ready to Get Started?
//         </motion.h2>
//         <p className="text-lg mb-6">Let us handle your home or office cleaning needs.</p>
//         <Link to="/book">
//           <button className="bg-white text-orange-600 px-6 py-3 font-bold rounded shadow hover:bg-orange-100 animate-pulse">
//             Book a Service
//           </button>
//         </Link>
//       </section>

//       <Footer />
//     </>
//   );
// }

// export default Ourcleaning;

//2nd attempt

// import { useState, useEffect } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Modal, Spin, Drawer } from "antd";
// import { motion } from "framer-motion";
// import Slider from "react-slick";
// import { FaStar, FaFilter } from "react-icons/fa";

// import Hero from "../../common/Hero";
// import Navbar from "../../common/Navbar";
// import Footer from "../../common/Footer";
// import BlogImage from "../../assests/images/hero.jpg";

// /**
//  * Ourcleaning.jsx
//  * Premium Light Theme — Emerald Harmony
//  * Primary Green: #1A8F5A
//  * Card Gray: #F7F7F7
//  *
//  * Note: This component injects Google Fonts (Playfair Display + Inter)
//  * automatically on mount. If you'd rather add fonts in index.html, remove the font injection.
//  */

// function Ourcleaning() {
//   // --- state
//   const [services, setServices] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [selectedSubcategory, setSelectedSubcategory] = useState("all");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [previewService, setPreviewService] = useState(null);

//   const [showFilterDrawer, setShowFilterDrawer] = useState(false);

//   const [showProviderModal, setShowProviderModal] = useState("");
//   const [providerName, setProviderName] = useState({ firstName: "", lastName: "" });
//   const navigate = useNavigate();

//   // API base
//   const API_BASE = process.env.REACT_APP_API_BASE;

//   // Inject Google Fonts (Playfair Display + Inter) for a premium look
//   useEffect(() => {
//     const id = "ourcleaning-google-fonts";
//     if (!document.getElementById(id)) {
//       const link = document.createElement("link");
//       link.id = id;
//       link.rel = "stylesheet";
//       link.href =
//         "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700&family=Playfair+Display:wght@400;600;700&display=swap";
//       document.head.appendChild(link);
//     }
//     // add body classes for fonts (safe fallback if Tailwind fontFamily not configured)
//     document.documentElement.style.setProperty("--font-heading", "'Playfair Display', serif");
//     document.documentElement.style.setProperty("--font-body", "'Inter', system-ui, sans-serif");
//   }, []);

//   // Get logged-in user info
//   useEffect(() => {
//     const auth = localStorage.getItem("auth");
//     if (auth) {
//       const user = JSON.parse(auth)?.user;
//       if (user) {
//         setProviderName({ firstName: user.firstName, lastName: user.lastName });
//         setShowProviderModal(user.role || "");
//       }
//     }
//   }, []);

//   // Fetch services
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         setLoading(true);
//         const res = await axios.get(`${API_BASE}/service/readAllService`);
//         const data = Array.isArray(res.data.data.services) ? res.data.data.services : [];
//         setServices(data);
//         const uniqueCategories = [...new Set(data.map((s) => s.category).filter(Boolean))];
//         setCategories(uniqueCategories);
//       } catch (err) {
//         console.error("Failed to load services:", err);
//         setError("Failed to load services. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchServices();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Highlight helper (keeps original behavior)
//   const highlightText = (text = "", search) => {
//     if (!search) return text;
//     try {
//       const regex = new RegExp(`(${search})`, "gi");
//       return String(text).replace(regex, `<span style="background-color: #fff59d; padding: 0 2px; border-radius: 2px;">$1</span>`);
//     } catch {
//       return text;
//     }
//   };

//   // Filtered services
//   const filteredServices = services.filter((s) => {
//     const name = s.name?.toLowerCase() || "";
//     const desc = s.description?.toLowerCase() || "";
//     const cat = s.category?.toLowerCase() || "";
//     const sub = s.subcategory?.toLowerCase() || "";

//     const matchesSearch = !searchTerm || name.includes(searchTerm.toLowerCase()) || desc.includes(searchTerm.toLowerCase());
//     const matchesCat = selectedCategory === "all" || cat === selectedCategory.toLowerCase();
//     const matchesSub = selectedSubcategory === "all" || sub === selectedSubcategory.toLowerCase();

//     return matchesSearch && matchesCat && matchesSub;
//   });

//   // small data for testimonials fallback
//   const testimonials = [
//     { name: "Aisha", feedback: "Outstanding service! Cleaners were on time and thorough.", img: "https://randomuser.me/api/portraits/women/68.jpg", rating: 5 },
//     { name: "Ali", feedback: "They made my office spotless. Highly recommended!", img: "https://randomuser.me/api/portraits/men/76.jpg", rating: 4 },
//     { name: "Fatima", feedback: "Great attention to detail. Will book again!", img: "https://randomuser.me/api/portraits/women/45.jpg", rating: 5 },
//   ];
//   const serviceArea = [
//     "Hayes",
//     "Hunslow",
//     "Southall",
//     "Uxbridge",
//     "Greenford",
//     "Northolt",
//     "Windsor",
//     "Ruislip",
//     "Harrow",
//     "Maidenhead",
//     "High Wycombe",
//   ];
//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     autoplay: true,
//     speed: 800,
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     responsive: [{ breakpoint: 1024, settings: { slidesToShow: 1 } }],
//   };

//   // Filter content (clean premium style)
//   const FilterContent = () => (
//     <div className="p-4" style={{ fontFamily: "var(--font-body)" }}>
//       <h3 className="text-xl font-semibold mb-4" style={{ color: "#1A8F5A", fontFamily: "var(--font-heading)" }}>
//         Filter by Category
//       </h3>

//       {/* All Categories Button */}
//       <button
//         onClick={() => {
//           setSelectedCategory("all");
//           setSelectedSubcategory("all");
//         }}
//         className={`block w-full text-left px-3 py-2 rounded-md mb-2 border`}
//         style={{
//           background: selectedCategory === "all" ? "#E6F6EE" : "#FFFFFF",
//           borderColor: selectedCategory === "all" ? "#1A8F5A" : "#E5E7EB",
//           color: selectedCategory === "all" ? "#1A8F5A" : "#1A1A1A",
//         }}
//       >
//         All Categories
//       </button>

//       {/* Loop through categories */}
//       {categories.map((cat) => {
//         // Get unique subcategories for this category
//         const subcategories = [...new Set(services.filter((s) => s.category === cat).map((s) => s.subcategory))].filter(Boolean);

//         return (
//           <div key={cat} className="mb-4">
//             {/* Category Button */}
//             <button
//               onClick={() => setSelectedCategory(cat)}
//               className="block w-full text-left px-3 py-2 rounded-md mb-1 border"
//               style={{
//                 background: selectedCategory === cat ? "#E6F6EE" : "#FFFFFF",
//                 borderColor: selectedCategory === cat ? "#1A8F5A" : "#E5E7EB",
//                 color: selectedCategory === cat ? "#1A8F5A" : "#1A1A1A",
//               }}
//             >
//               ◆ {cat}
//             </button>

//             {/* Always show subcategories */}
//             <div className="pl-4">
//               {/* <button
//               onClick={() => setSelectedSubcategory("all")}
//               className="block w-full text-left px-3 py-1 rounded-md mb-1 border text-sm"
//               style={{
//                 background: selectedSubcategory === "all" && selectedCategory === cat ? "#E6F6EE" : "#FFFFFF",
//                 borderColor: selectedSubcategory === "all" && selectedCategory === cat ? "#1A8F5A" : "#E5E7EB",
//                 color: selectedSubcategory === "all" && selectedCategory === cat ? "#1A8F5A" : "#1A1A1A",
//               }}
//             >
//               All
//             </button> */}

//               {subcategories.map((sub) => (
//                 <button
//                   key={sub}
//                   onClick={() => {
//                     setSelectedCategory(cat);
//                     setSelectedSubcategory(sub);
//                   }}
//                   className="block w-full text-left px-3 py-1 rounded-md mb-1 border text-sm"
//                   style={{
//                     background: selectedSubcategory === sub ? "#E6F6EE" : "#FFFFFF",
//                     borderColor: selectedSubcategory === sub ? "#1A8F5A" : "#E5E7EB",
//                     color: selectedSubcategory === sub ? "#1A8F5A" : "#1A1A1A",
//                   }}
//                 >
//                   {sub}
//                 </button>
//               ))}
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   );


//   // --- Render
//   return (
//     <>
//       {/* Welcome Modal */}
//       <Modal open={Boolean(showProviderModal)} onCancel={() => setShowProviderModal("")} footer={null} centered>
//         <div className="text-center py-6" style={{ fontFamily: "var(--font-body)" }}>
//           {showProviderModal === "provider" ? (
//             <>
//               <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "var(--font-heading)", color: "#1A8F5A" }}>
//                 Welcome Dear Employee!
//               </h2>
//               <p className="text-lg">
//                 Mr. {providerName.firstName} {providerName.lastName}, check your profile for orders.
//               </p>
//               <button
//                 onClick={() => navigate("/Profile")}
//                 className="mt-6 w-60 py-2 rounded text-white font-semibold"
//                 style={{ background: "#1A8F5A" }}
//               >
//                 Go to Profile
//               </button>
//             </>
//           ) : showProviderModal === "user" ? (
//             <>
//               <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "var(--font-heading)", color: "#1A8F5A" }}>
//                 Welcome Dear Customer!
//               </h2>
//               <p className="text-lg">
//                 {providerName.firstName} {providerName.lastName}, view your order history in your profile.
//               </p>
//               <button
//                 onClick={() => navigate("/Profile")}
//                 className="mt-6 w-60 py-2 rounded text-white font-semibold"
//                 style={{ background: "#1A8F5A" }}
//               >
//                 Go to Profile
//               </button>
//             </>
//           ) : showProviderModal === "admin" ? (
//             <>
//               <h2 className="text-2xl font-semibold mb-2" style={{ fontFamily: "var(--font-heading)", color: "#1A8F5A" }}>
//                 Hello Admin!
//               </h2>
//               <p className="text-lg">{providerName.firstName} {providerName.lastName}, open your dashboard below.</p>
//               <button onClick={() => navigate("/admin")} className="mt-6 w-60 py-2 rounded text-white font-semibold" style={{ background: "#1A8F5A" }}>
//                 Go to Admin Dashboard
//               </button>
//             </>
//           ) : null}
//         </div>
//       </Modal>

//       {/* Navbar: keep your shared Navbar component (assumes it supports white bg) */}
//       <div style={{ background: "#FFFFFF", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
//         <Navbar />
//       </div>

//       {/* Hero */}
//       <Hero
//         text="Installation Services"
//         text1="Blinds • Carpets • Furniture • Sofas"
//         image={BlogImage}
//       // If Hero accepts classes/props you can pass theme props; otherwise Hero will render as before.
//       />

//       {/* Main Services Section */}
//       <section className="py-16 px-4 md:px-8" style={{ background: "#FFFFFF", color: "#1A1A1A", fontFamily: "var(--font-body)" }}>
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl font-bold text-center mb-10" style={{ fontFamily: "var(--font-heading)", color: "#1A8F5A" }}>
//             Our Services
//           </h2>

//           <div className="flex flex-col md:flex-row gap-8">
//             {/* Sidebar for Desktop */}
//             <aside className="hidden md:block md:w-1/4">
//               <div className="rounded-xl p-5" style={{ background: "#F7F7F7", border: "1px solid #E5E7EB" }}>
//                 <FilterContent />
//               </div>
//             </aside>

//             {/* Mobile Filter Button */}
//             <div className="md:hidden mb-4 flex justify-center">
//               <button
//                 onClick={() => setShowFilterDrawer(true)}
//                 className="flex items-center gap-2 px-4 py-2 rounded-md text-white font-semibold"
//                 style={{ background: "#1A8F5A" }}
//               >
//                 <FaFilter /> Filter
//               </button>
//             </div>

//             {/* Drawer for Mobile */}
//             <Drawer
//               title="Filter Services"
//               placement="left"
//               onClose={() => setShowFilterDrawer(false)}
//               open={showFilterDrawer}
//               bodyStyle={{ backgroundColor: "#ffffff", color: "#1A1A1A" }}
//             >
//               <FilterContent />
//             </Drawer>

//             {/* Main grid */}
//             <div className="flex-1">
//               {/* Search */}
//               <div className="mb-6">
//                 <input
//                   type="search"
//                   value={searchTerm}
//                   onChange={(e) => setSearchTerm(e.target.value)}
//                   placeholder="Search services, carpets, blinds, sofas..."
//                   className="w-full px-4 py-3 rounded-md border"
//                   style={{ borderColor: "#E5E7EB", background: "#FFFFFF", color: "#1A1A1A" }}
//                 />
//               </div>

//               {loading ? (
//                 <div className="flex justify-center items-center py-20">
//                   <Spin size="large" />
//                 </div>
//               ) : error ? (
//                 <p className="text-center text-red-500">{error}</p>
//               ) : (
//                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
//                   {filteredServices.length ? (
//                     filteredServices.map((service, i) => (
//                       <motion.div
//                         key={i}
//                         initial={{ opacity: 0, y: 20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         transition={{ duration: 0.35 }}
//                         viewport={{ once: true }}
//                         className="group relative rounded-2xl overflow-hidden border border-gray-200 bg-white shadow-sm hover:shadow-lg transition-shadow duration-300"
//                       >
//                         <div className="relative">
//                           <img
//                             src={service.image || "https://source.unsplash.com/400x300/?interior,sofa"}
//                             alt={service.name}
//                             className="w-full h-56 object-cover transition-transform duration-500 group-hover:scale-105"
//                           />
//                           {service.popular && (
//                             <div className="absolute top-3 left-3 bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full">
//                               Popular
//                             </div>
//                           )}
//                           {/* Hover Book Button */}
//                           <Link
//                             to="/book"
//                             className="absolute bottom-4 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
//                           >
//                             <button className="px-5 py-2 rounded-full font-semibold text-white bg-green-600 hover:bg-green-700 shadow-md">
//                               Book Now
//                             </button>
//                           </Link>
//                         </div>

//                         <div className="p-5">
//                           <h3
//                             className="text-lg font-bold line-clamp-1 text-gray-900"
//                             dangerouslySetInnerHTML={{ __html: highlightText(service.name, searchTerm) }}
//                           />
//                           <p
//                             className="text-sm text-gray-600 line-clamp-2 mt-2"
//                             dangerouslySetInnerHTML={{ __html: highlightText(service.description, searchTerm) }}
//                           />
//                         </div>
//                       </motion.div>
//                     ))
//                   ) : (
//                     <p className="text-center text-gray-500 col-span-full">No matching services found.</p>
//                   )}
//                 </div>

//               )}
//             </div>
//           </div>
//         </div>

//         {/* Preview Modal */}
//         <Modal
//           open={!!previewService}
//           onCancel={() => setPreviewService(null)}
//           footer={null}
//           centered
//           width={900}
//           bodyStyle={{ maxHeight: "90vh", overflowY: "auto" }}
//         >
//           {previewService && (
//             <div className="flex flex-col md:flex-row gap-6 items-start" style={{ fontFamily: "var(--font-body)" }}>
//               <div className="md:w-2/3 w-full h-96 overflow-hidden">
//                 <img
//                   src={previewService.image || "https://source.unsplash.com/900x700/?interior,furniture"}
//                   alt={previewService.name}
//                   className="w-full h-full object-cover rounded-lg"
//                 />
//               </div>
//               <div className="md:w-1/3 w-full flex flex-col justify-center">
//                 <h3 className="text-3xl font-bold mb-4" style={{ color: "#1A8F5A", fontFamily: "var(--font-heading)" }}>
//                   {previewService.name}
//                 </h3>
//                 <p className="text-gray-700 mb-6">{previewService.description}</p>
//                 <Link to="/book">
//                   <button className="px-6 py-3 rounded font-semibold" style={{ background: "#1A8F5A", color: "#FFFFFF" }}>
//                     Book Now
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           )}
//         </Modal>
//       </section>

//       {/* Main Services areas */}
//       <div className="w-full overflow-hidden py-3 bg-green-900">
//         <div
//           className="flex whitespace-nowrap"
//           style={{
//             animation: 'mySlide 25s linear infinite',
//           }}
//         >
//           {/* Keyframes in a <style> tag */}
//           <style>
//             {`
//         @keyframes mySlide {
//           0% { transform: translateX(0); }
//           100% { transform: translateX(-50%); }
//         }
//       `}
//           </style>

//           {/* First Loop */}
//           {serviceArea.map((name, i) => (
//             <span key={i} className="text-yellow-400 font-semibold text-lg mx-6">
//               {name}
//             </span>
//           ))}

//           {/* Duplicate Loop for infinite scroll */}
//           {serviceArea.map((name, i) => (
//             <span key={`dup-${i}`} className="text-yellow-400 font-semibold text-lg mx-6">
//               {name}
//             </span>
//           ))}
//         </div>
//       </div>


//       {/* Testimonials */}
//       <section className="py-16 px-4" style={{ background: "#F7F7F7", fontFamily: "var(--font-body)" }}>
//         <div className="max-w-6xl mx-auto text-center">
//           <h2 className="text-4xl font-bold mb-8" style={{ fontFamily: "var(--font-heading)", color: "#1A8F5A" }}>
//             Happy Clients
//           </h2>
//           <Slider {...sliderSettings}>
//             {testimonials.map((client, i) => (
//               <div key={i} className="p-6 rounded-xl mx-4" style={{ background: "#FFFFFF", boxShadow: "0 10px 30px rgba(18,24,30,0.04)" }}>
//                 <img src={client.img} alt={client.name} className="w-20 h-20 rounded-full mx-auto mb-4 border-2" style={{ borderColor: "#E5E7EB" }} />
//                 <p className="italic mb-4">“{client.feedback}”</p>
//                 <div className="flex justify-center mb-2">
//                   {[...Array(client.rating)].map((_, idx) => (
//                     <FaStar key={idx} className="text-yellow-400" />
//                   ))}
//                 </div>
//                 <h4 className="mt-2 font-semibold">{client.name}</h4>
//               </div>
//             ))}
//           </Slider>
//         </div>
//       </section>

//       <div className="flex flex-col md:flex-row justify-center items-center py-10 md:py-16 text-center md:text-left bg-white border-t border-gray-200">

//         {/* 1. Contact Us Section (First Flex Item) */}
//         <div className="flex flex-col items-center md:items-end md:border-r md:border-gray-300 md:pr-12 lg:pr-24 mb-8 md:mb-0">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">Contact Us</h3>
//           <p className="text-gray-600 mb-1">Leave a message and we will be in touch</p>
//           <a
//             href="mailto:blindsmf@gmail.com"
//             className="text-arena-blue hover:text-blue-700 font-medium transition duration-200"
//           >
//             blindsmf@gmail.com
//           </a>
//         </div>

//         {/* 2. Call Arena Section (Second Flex Item) */}
//         <div className="flex flex-col items-center md:items-start md:pl-12 lg:pl-24">
//           <h3 className="text-xl font-semibold text-gray-800 mb-2">Call MF Blind</h3>
//           <a
//             href="https://wa.me/447405264139"
//             target="_blank"
//             rel="noopener noreferrer"
//             className=" text-gray-600font-semibold"
//           >
//             +44 7405 264139
//           </a>
//           <p className="text-gray-600">
//             <span className="font-semibold">Weekdays:</span> 9.00am - 5.00pm
//           </p>
//         </div>

//       </div>
//       {/* CTA */}
//       <section className="py-16 px-4" style={{ background: "#FFFFFF", fontFamily: "var(--font-body)" }}>
//         <div className="max-w-4xl mx-auto text-center">
//           <motion.h2
//             initial={{ opacity: 0, scale: 0.98 }}
//             whileInView={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.5 }}
//             className="text-4xl font-bold mb-4"
//             style={{ fontFamily: "var(--font-heading)", color: "#1A8F5A" }}
//           >
//             Ready to Transform Your Space?
//           </motion.h2>
//           <p className="text-lg mb-6 text-gray-700">Premium blinds, carpets, and furniture — installed and styled for your home.</p>
//           <Link to="/book">
//             <button className="px-6 py-3 font-bold rounded shadow-md" style={{ background: "#1A8F5A", color: "#FFFFFF" }}>
//               Book a Service
//             </button>
//           </Link>
//         </div>
//       </section>

//       <Footer />
//     </>
//   );
// }

// export default Ourcleaning;

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal, Spin, Drawer } from "antd";
import { motion } from "framer-motion";
import Slider from "react-slick";
import { FaStar, FaFilter } from "react-icons/fa";

import Hero from "../../common/Hero";
import Navbar from "../../common/Navbar";
import Footer from "../../common/Footer";
import BlogImage from "../../assests/images/hero.jpg";

// --- GLOBAL CONFIGURATION ---
const CATEGORY_ORDER = ['Blinds', 'Carpets', 'Furniture', 'Sofa Collections'];

// Helper function to group services by category
const groupServicesByCategory = (services) => {
  return services.reduce((acc, service) => {
    const categoryName = service.category;
    if (categoryName && CATEGORY_ORDER.includes(categoryName)) {
      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }
      acc[categoryName].push(service);
    }
    return acc;
  }, {});
};

function Ourcleaning() {
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState({ category: [], subcategory: [] });
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [previewService, setPreviewService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const [showProviderModal, setShowProviderModal] = useState("");
  const [providerName, setProviderName] = useState({ firstName: "", lastName: "" });

  // Track visible card index per category for slide functionality
  const [visibleIndex, setVisibleIndex] = useState({});

  const navigate = useNavigate();
  const API_BASE = process.env.REACT_APP_API_BASE;

  // Google Fonts
  useEffect(() => {
    const id = "ourcleaning-google-fonts";
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700&family=Playfair+Display:wght@400;600;700&display=swap";
      document.head.appendChild(link);
    }
    document.documentElement.style.setProperty("--font-heading", "'Playfair Display', serif");
    document.documentElement.style.setProperty("--font-body", "'Inter', system-ui, sans-serif");
  }, []);

  // Load user info
  useEffect(() => {
    const auth = localStorage.getItem("auth");
    if (auth) {
      const user = JSON.parse(auth)?.user;
      if (user) {
        setProviderName({ firstName: user.firstName, lastName: user.lastName });
        setShowProviderModal(user.role || "");
      }
    }
  }, []);

  // Fetch services
  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_BASE}/service/readAllService`);
        const data = Array.isArray(res.data.data.services) ? res.data.data.services : [];
        setServices(data);
        const uniqueCategories = [...new Set(data.map(s => s.category).filter(c => CATEGORY_ORDER.includes(c)))];
        setCategories(uniqueCategories);
      } catch (err) {
        console.error("Failed to load services:", err);
        setError("Failed to load services. Please try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, [API_BASE]);

  // Highlight search
  const highlightText = (text = "", search) => {
    if (!search) return text;
    try {
      const regex = new RegExp(`(${search})`, "gi");
      return String(text).replace(regex, `<span class="bg-yellow-200 px-1 rounded">$1</span>`);
    } catch {
      return text;
    }
  };

  // Filtered services
  const filteredServices = services.filter(s => {
    const name = s.name?.toLowerCase() || "";
    const desc = s.description?.toLowerCase() || "";
    const cat = s.category || "";
    const sub = s.subcategory || "";

    const matchesSearch = !searchTerm || name.includes(searchTerm.toLowerCase()) || desc.includes(searchTerm.toLowerCase());
    const matchesCat = selectedFilters.category.length === 0 || selectedFilters.category.includes(cat);
    const matchesSub = selectedFilters.subcategory.length === 0 || selectedFilters.subcategory.includes(sub);

    return matchesSearch && matchesCat && matchesSub;
  });

  const groupedServices = groupServicesByCategory(filteredServices);

  // Slide functions
  const showNext = (categoryName, total) => {
    setVisibleIndex(prev => {
      const current = prev[categoryName] || 0;
      if (current + 4 >= total) return prev;
      return { ...prev, [categoryName]: current + 1 };
    });
  };

  const showPrev = (categoryName) => {
    setVisibleIndex(prev => {
      const current = prev[categoryName] || 0;
      if (current === 0) return prev;
      return { ...prev, [categoryName]: current - 1 };
    });
  };

  // Filter component
  const FilterContent = ({ selectedFilters, setSelectedFilters }) => {
    const handleFilterChange = (filterKey, value, isChecked) => {
      setSelectedFilters(prev => {
        const currentSelections = prev[filterKey] || [];
        const newSelections = isChecked
          ? [...new Set([...currentSelections, value])]
          : currentSelections.filter(item => item !== value);
        return { ...prev, [filterKey]: newSelections };
      });
    };

    const getSubcategories = (cat) =>
      [...new Set(services.filter(s => s.category === cat).map(s => s.subcategory).filter(Boolean))];

    const isCatChecked = (cat) => selectedFilters.category.includes(cat);
    const isSubChecked = (sub) => selectedFilters.subcategory.includes(sub);

    return (
      <div className="p-6 bg-white rounded-2xl shadow-lg font-body">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h3 className="text-xl font-semibold text-green-700 font-heading">Filter Services</h3>
          <button
            onClick={() => setSelectedFilters({ category: [], subcategory: [] })}
            className="text-red-600 hover:text-red-800 text-sm font-semibold"
          >
            Clear All
          </button>
        </div>

        {/* Categories */}
        <div className="mb-6">
          <h4 className="font-bold text-gray-800 text-lg mb-3 border-b pb-2">Categories</h4>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {categories.map((cat) => (
              <label
                key={cat}
                htmlFor={`cat-${cat}`}
                className="flex items-center p-2 rounded-lg hover:bg-green-50 cursor-pointer transition"
              >
                <input
                  type="checkbox"
                  id={`cat-${cat}`}
                  checked={isCatChecked(cat)}
                  onChange={(e) => handleFilterChange("category", cat, e.target.checked)}
                  className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                />
                <span className="ml-3 font-medium text-gray-700">{cat}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Subcategories */}
        {selectedFilters.category.length > 0 && (
          <div className="mb-4">
            <h4 className="font-bold text-gray-800 text-lg mb-3 border-b pb-2">Subcategories</h4>
            <div className="space-y-3 max-h-64 overflow-y-auto">
              {categories.filter(isCatChecked).map((cat) => (
                <div key={cat}>
                  <h5 className="font-semibold text-green-700 text-sm mb-2">{cat}</h5>
                  <div className="space-y-1 pl-3">
                    {getSubcategories(cat).map((sub) => (
                      <label
                        key={sub}
                        htmlFor={`sub-${sub}`}
                        className="flex items-center p-1 rounded hover:bg-green-50 cursor-pointer transition"
                      >
                        <input
                          type="checkbox"
                          id={`sub-${sub}`}
                          checked={isSubChecked(sub)}
                          onChange={(e) =>
                            handleFilterChange("subcategory", sub, e.target.checked)
                          }
                          className="h-4 w-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                        />
                        <span className="ml-2 text-gray-600 text-sm">{sub}</span>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

    );
  };

  // Preview Modal
  const openModal = (service) => {
    setPreviewService(service);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setPreviewService(null);
    setIsModalOpen(false);
  };

  // Testimonials & Service Areas
  const testimonials = [
    { name: "Aisha", feedback: "Outstanding service! Cleaners were on time and thorough.", img: "https://randomuser.me/api/portraits/women/68.jpg", rating: 5 },
    { name: "Ali", feedback: "They made my office spotless. Highly recommended!", img: "https://randomuser.me/api/portraits/men/76.jpg", rating: 4 },
    { name: "Fatima", feedback: "Great attention to detail. Will book again!", img: "https://randomuser.me/api/portraits/women/45.jpg", rating: 5 },
  ];

  const serviceArea = [
    "Hayes", "Hunslow", "Southall", "Uxbridge", "Greenford", "Northolt",
    "Windsor", "Ruislip", "Harrow", "Maidenhead", "High Wycombe"
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    autoplay: true,
    speed: 800,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, dots: false } }
    ],
  };

  // --------------------- Render ---------------------
  return (
    <>
      {/* Provider Welcome Modal */}
      <Modal open={Boolean(showProviderModal)} onCancel={() => setShowProviderModal("")} footer={null} centered>
        <div className="text-center py-6 font-body">
          {showProviderModal === "provider" && (
            <>
              <h2 className="text-2xl font-semibold mb-2 font-heading text-green-700">Welcome Dear Employee!</h2>
              <p className="text-lg">Mr. {providerName.firstName} {providerName.lastName}, check your profile for orders.</p>
              <button onClick={() => navigate("/Profile")} className="mt-6 w-60 py-2 rounded text-white font-semibold bg-green-700">Go to Profile</button>
            </>
          )}
          {showProviderModal === "user" && (
            <>
              <h2 className="text-2xl font-semibold mb-2 font-heading text-green-700">Welcome Dear Customer!</h2>
              <p className="text-lg">{providerName.firstName} {providerName.lastName}, view your order history in your profile.</p>
              <button onClick={() => navigate("/Profile")} className="mt-6 w-60 py-2 rounded text-white font-semibold bg-green-700">Go to Profile</button>
            </>
          )}
          {showProviderModal === "admin" && (
            <>
              <h2 className="text-2xl font-semibold mb-2 font-heading text-green-700">Hello Admin!</h2>
              <p className="text-lg">{providerName.firstName} {providerName.lastName}, open your dashboard below.</p>
              <button onClick={() => navigate("/admin")} className="mt-6 w-60 py-2 rounded text-white font-semibold bg-green-700">Go to Admin Dashboard</button>
            </>
          )}
        </div>
      </Modal>

      {/* Preview Modal */}
      <Modal
        open={isModalOpen}
        onCancel={closeModal}
        footer={null}
        centered
        width={900}
        bodyStyle={{ maxHeight: "90vh", overflowY: "auto", padding: "0" }}
        className="rounded-xl"
      >
        {previewService && (
          <div className="flex flex-col md:flex-row gap-4 md:gap-6 p-4 md:p-6">
            <div className="md:w-2/3 w-full h-96 md:h-auto overflow-hidden rounded-lg">
              <img
                src={previewService.image || "https://source.unsplash.com/900x700/?interior,sofa"}
                alt={previewService.name}
                className="w-full md:w-2/3 h-64 sm:h-80 md:h-auto overflow-hidden rounded-lg"
              />
            </div>
            <div className="md:w-1/3 w-full flex flex-col justify-center space-y-4">
              <h3 className="text-2xl sm:text-3xl font-bold text-lime-600">{previewService.name}</h3>
              <p className="text-gray-700 text-sm sm:text-base">{previewService.description}</p>
              <Link to="/book">
                <button className="bg-lime-600 hover:bg-lime-700 text-white px-6 py-3 rounded-lg font-semibold shadow-md transition">Book Now</button>
              </Link>
            </div>
          </div>
        )}
      </Modal>

      {/* Navbar */}
      <div className="bg-white shadow-sm">
        <Navbar />
      </div>

      {/* Hero */}
      <Hero text="Installation Services" text1="Blinds • Carpets • Furniture • Sofas" image={BlogImage} />

      {/* Services Section */}
      <section className="py-20 px-4 md:px-8 bg-white font-body text-gray-900">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-10 text-green-700" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Services
          </h2>          <div className="flex flex-col md:flex-row gap-8">
            {/* Sidebar Desktop */}
            <aside className="hidden md:block md:w-1/3 lg:w-1/4">
              <div className="rounded-xl p-5 bg-gray-100 border border-gray-200 shadow-sm">
                <FilterContent selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} />
              </div>
            </aside>

            {/* Mobile Filter Button */}
            <div className="md:hidden mb-4 flex justify-center">
              <button onClick={() => setShowFilterDrawer(true)} className="flex items-center gap-2 px-4 py-2 rounded-md text-white font-semibold bg-green-700">
                <FaFilter /> Filter
              </button>
            </div>

            {/* Mobile Drawer */}
            <Drawer
              title="Filter Services"
              placement="left"
              onClose={() => setShowFilterDrawer(false)}
              open={showFilterDrawer}
              bodyStyle={{ backgroundColor: "#ffffff", color: "#1A1A1A" }}
            >
              <FilterContent selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} />
            </Drawer>

            {/* Services Grid */}
            <div className="flex-1">
              {/* Search */}
              <div className="mb-6">
                <input
                  type="search"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Search: Blinds • Carpets • Furniture • Sofa Collections"
                  className="w-full px-4 py-3 rounded-md border text-sm sm:text-base"
                />
              </div>

              {loading ? (
                <div className="flex justify-center items-center py-20">
                  <Spin size="large" />
                </div>
              ) : error ? (
                <p className="text-center text-red-500">{error}</p>
              ) : (
                <div className="space-y-12">
                  {CATEGORY_ORDER.map((categoryName) => {
                    const servicesInSection = groupedServices[categoryName];
                    if (!servicesInSection || servicesInSection.length === 0) return null;

                    const start = visibleIndex[categoryName] || 0;
                    const end = start + 3; // show up to 4 items (will auto-wrap)

                    return (
                      <div key={categoryName}>
                        {/* Header with next/prev */}
                        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end gap-3 mb-4">
                          <h2 className="text-2xl font-bold text-green-700 font-heading">
                            {categoryName}
                          </h2>

                          <div className="flex gap-2">
                            <button
                              onClick={() => showPrev(categoryName)}
                              className="p-2 rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
                            >
                              ←
                            </button>
                            <button
                              onClick={() => showNext(categoryName, servicesInSection.length)}
                              className="p-2 rounded-full bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
                            >
                              →
                            </button>
                          </div>
                        </div>

                        {/* Responsive Grid Instead of Forced Widths */}
                        <div
                          className="
                grid 
                grid-cols-1 
                sm:grid-cols-2 
                lg:grid-cols-3 
                xl:grid-cols-4 
                gap-6
              "
                        >
                          {servicesInSection.slice(start, end).map((service, i) => (
                            <motion.div
                              key={service.name + i}
                              initial={{ opacity: 0, y: 20 }}
                              whileInView={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.35, delay: i * 0.05 }}
                              viewport={{ once: true }}
                              className="bg-white rounded-2xl shadow-md overflow-hidden group"
                            >
                              {/* Image */}
                              <div className="relative">
                                <img
                                  src={
                                    service.image ||
                                    "https://source.unsplash.com/400x300/?interior,sofa"
                                  }
                                  alt={service.name}
                                  className="w-full h-56 object-cover transition-transform duration-500 group-hover:scale-105"
                                />

                                {service.popular && (
                                  <div className="absolute top-3 left-3 bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full">
                                    Popular
                                  </div>
                                )}

                                <button
                                  onClick={() => openModal(service)}
                                  className="
                        absolute bottom-4 left-1/2 -translate-x-1/2 
                        opacity-0 group-hover:opacity-100 
                        transition-opacity duration-300 
                        bg-green-600 text-white px-5 py-2 
                        rounded-full font-semibold
                      "
                                >
                                  View
                                </button>
                              </div>

                              {/* Content */}
                              <div className="p-4">
                                <h3 className="font-bold text-lg text-gray-800">{service.name}</h3>

                                {/* Star Rating */}
                                <div className="flex items-center gap-1 mt-1">
                                  {[...Array(5)].map((_, idx) => (
                                    <FaStar
                                      key={idx}
                                      className={`h-4 w-4 ${idx < (service.rating || 4) ? "text-yellow-400" : "text-gray-300"}`}
                                    />
                                  ))}
                                </div>

                                {/* Description */}
                                {service.description && (
                                  <p className="text-gray-600 text-sm sm:text-base mt-2 line-clamp-3">
                                    {service.description}
                                  </p>
                                )}
                              </div>

                            </motion.div>
                          ))}
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>


          </div>
        </div>
      </section>
      {/* Service Areas Marquee */}
      <div className="overflow-hidden bg-lime-600 py-2">
        <div className="flex animate-marquee whitespace-nowrap">
          {/* Original list */}
          {serviceArea.map((area, idx) => (
            <span key={idx} className="mx-8 text-white font-semibold text-sm sm:text-base">
              {area}
            </span>
          ))}
          {/* Duplicate list for seamless infinite scroll */}
          {serviceArea.map((area, idx) => (
            <span key={`dup-${idx}`} className="mx-8 text-white font-semibold text-sm sm:text-base">
              {area}
            </span>
          ))}
        </div>

        <style jsx>{`
    @keyframes marquee {
      0% { transform: translateX(0%); }
      100% { transform: translateX(-50%); }
    }
    .animate-marquee {
      display: inline-flex;
      min-width: 200%; /* ensures duplicated content fits */
      animation: marquee 20s linear infinite;
    }
  `}</style>
      </div>

      {/* Testimonials Section */}
      <section className="py-8 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <h2 className="text-5xl font-bold mb-10 text-center text-green-700" style={{ fontFamily: "'Playfair Display', serif" }}>
            What Our Clients Say
          </h2>          <Slider {...sliderSettings}>
            {testimonials.map((t, i) => (
              <div key={i} className="px-4">
                <div className="bg-white rounded-xl shadow-md p-6 text-center">
                  <img src={t.img} alt={t.name} className="w-24 h-24 mx-auto rounded-full mb-4" />
                  <h3 className="font-semibold text-lg mb-2">{t.name}</h3>
                  <p className="text-gray-600 mb-2">{t.feedback}</p>
                  <div className="flex justify-center gap-1">
                    {[...Array(5)].map((_, idx) => (
                      <FaStar key={idx} className={`h-4 w-4 ${idx < t.rating ? "text-yellow-400" : "text-gray-300"}`} />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>


      {/* Footer */}
      <Footer />
    </>
  );
}

export default Ourcleaning;
